import React, { useEffect, useRef, useState } from 'react';

const SearchableSelect = ({
	isLoading,
	options = [],
	onSelect,
	onSearch,
	placeholder,
	selectedValue,
	isSearchIconClicked = false,
	isFromTeamPage = false
}) => {
	const [searchTerm, setSearchTerm] = useState(selectedValue);
	const [selectedIndex, setSelectedIndex] = useState(0);
	const [isFocused, setIsFocused] = useState(isSearchIconClicked);
	const inputRef = useRef(null);
	const optionsContainerRef = useRef(null);

	useEffect(() => {
		if (isSearchIconClicked) {
			setIsFocused(isSearchIconClicked);
			inputRef.current.focus();
		}
	}, [isSearchIconClicked]);

	useEffect(() => {
		setSearchTerm(selectedValue);
	}, [selectedValue]);

	useEffect(() => {
		if (isLoading) {
			setSelectedIndex(0);
		}
	}, [isLoading]);

	useEffect(() => {
		const handleClickOutside = (event) => {
			if (
				inputRef.current &&
				!inputRef.current.contains(event.target) &&
				optionsContainerRef.current &&
				!optionsContainerRef.current.contains(event.target)
			) {
				setIsFocused(false);
			}
		};

		document.addEventListener('mousedown', handleClickOutside);

		return () => {
			document.removeEventListener('mousedown', handleClickOutside);
		};
	}, []);

	const handleInputFocus = () => {
		setIsFocused(true);
	};

	const handleInputChange = (event) => {
		const encodedName = event.target.value;
		onSearch(encodedName);
		setSearchTerm(encodedName);
	};

	const onSelectClick = (option) => {
		const encodedLabel = option?.label;
		setSearchTerm(encodedLabel);
		onSelect({ ...option, label: encodedLabel });
	};

	const handleKeyDown = (event) => {
		if (event.key === 'ArrowUp') {
			event.preventDefault();
			setSelectedIndex((prevIndex) => Math.max(prevIndex - 1, 0));
		} else if (event.key === 'ArrowDown') {
			event.preventDefault();
			setSelectedIndex((prevIndex) => Math.min(prevIndex + 1, options.length - 1));
		} else if (event.key === 'Enter') {
			onSelectClick(options[selectedIndex]);
		}

		// Scroll to the selected option
		const selectedOptionElement = document.querySelector('.options-list li.selected');
		if (selectedOptionElement) {
			selectedOptionElement.scrollIntoView({
				behavior: 'smooth',
				block: 'nearest'
			});
		}
	};

	return (
		<div>
			<div className="seacrh-input">
				<input
					placeholder={placeholder}
					className="search-input"
					type="text"
					autoComplete="off"
					ref={inputRef}
					value={searchTerm}
					onChange={handleInputChange}
					onFocus={handleInputFocus}
					autoFocus={isFocused}
					onKeyDown={options?.length > 0 && !isLoading ? handleKeyDown : null}
				/>
			</div>
			{isFocused && !isLoading && (
				<ul className="options-list" ref={optionsContainerRef}>
					{options?.length > 0 ? (
						options?.map((option, index) => (
							<li
								key={option?.value}
								className={index === selectedIndex ? 'selected' : ''}
								onClick={() => onSelectClick(option)}
							>
								{isFromTeamPage ? (
									<>
										<img
											style={{
												width: '32px',
												height: '32px',
												borderRadius: '100px'
											}}
											src={
												option?.profilePicDocument?.docUrl ||
												`${process.env.PUBLIC_URL}/images/pro_pic_default.svg`
											}
											className="mr-2"
											alt="profile"
										/>
										{option?.label}
										<span className="brand-common-design ml-1">
											{option?.designation}
										</span>
									</>
								) : (
									option?.label
								)}
							</li>
						))
					) : (
						<li className="selected text-align--center">
							No {isFromTeamPage ? 'members' : 'designs'}
						</li>
					)}
				</ul>
			)}
		</div>
	);
};

export default SearchableSelect;
